export default __webpack_public_path__ + "static/media/bv_icon.c36fe3e1.svg";